{
  "App": {
    "Title": "Cenorion"
  },
  "Nav": {
    "Primary": "Main navigation",
    "Dashboard": "Dashboard",
    "Devices": "Devices",
    "AppCustomization": "App customization",
    "Profile": "Profile",
    "ViewProfile": "View profile",
    "PlansWorkflows": "Plans & Workflows",
    "Support": "Support",
    "SupportEmail": "Email",
    "SupportHotline": "Hotline",
    "SignOutConfirm": {
      "Title": "Sign out?",
      "Body": "You’ll need to sign in again to continue."
    }
  },
  "Search": {
    "Placeholder": "Search IMEI, device, workflows, plans..",
    "Unavailable": "Search is not available on this page yet.",
    "Clear": "Clear search",
    "Results": "Results",
    "Groups": {
      "DEVICE": "Devices",
      "WORKFLOW": "Workflows",
      "PLAN": "Plans",
      "CONFIGURATION": "Configurations"
    },
    "GroupCount": "{{group}} · {{count}}",
    "ViewAll": "View all",
    "NoResults": "No results for \"{{query}}\"",
    "Detail": {
      "Workflow": "{{devices}} · Updated {{updated}}",
      "Plan": "{{service}} · {{devices}}",
      "DeviceCount": "{{formatted}} devices",
      "DeviceCount_one": "{{formatted}} device",
      "DeviceCount_other": "{{formatted}} devices",
      "Configuration": "Configuration · {{section}}"
    },
    "Areas": {
      "USERS": "Users",
      "ROLES": "Roles and permissions",
      "WHITELIST": "Whitelist restrictions",
      "APP_CUSTOMISATION": "Application customisation"
    }
  },
  "Onboarding": {
    "Label": "Product tour",
    "Progress": "{{current}}/{{total}}",
    "Actions": {
      "Continue": "Continue",
      "Done": "Done",
      "Dismiss": "Dismiss tour"
    },
    "Steps": {
      "Dashboard": {
        "Title": "Dashboard",
        "Body": "Your starting point. See what needs your attention, how your program is trending, and a quick snapshot of every device's state — enrolled, active, locked, or released."
      },
      "Devices": {
        "Title": "Devices",
        "Body": "Every device lives here. Browse the registry by IMEI, dig into a device's summary, connectivity, security and history, work through the provisioning queue, and register new devices when they arrive."
      },
      "PlansWorkflows": {
        "Title": "Services & Workflows",
        "Body": "Where you set the rules. Build and manage the plans your customers are on, and the workflows that decide what happens at each stage — reminders, lock steps, escalations. One workflow can power many plans."
      },
      "AppCustomization": {
        "Title": "Configuration",
        "Body": "Platform-wide settings. Message templates, quiet hours and calendars, users and roles, branding, device controls, and the audit log. If it applies across the whole portal, it's in here."
      },
      "Search": {
        "Title": "Search",
        "Body": "Jump to anything fast. Search by IMEI, plan or workflow name — results group by type so you can go straight to the record you need."
      },
      "Profile": {
        "Title": "Your avatar",
        "Body": "Everything about you — profile, password, MFA, sessions. You can also replay this tour anytime, or reach support from here."
      }
    }
  },
  "Theme": {
    "Label": "Theme",
    "Light": "Light",
    "Dark": "Dark"
  },
  "Common": {
    "Actions": {
      "SignIn": "Sign in",
      "SignOut": "Sign out",
      "Edit": "Edit",
      "Save": "Save",
      "Cancel": "Cancel",
      "Close": "Close"
    },
    "Trend": {
      "Up": "Up",
      "Down": "Down",
      "Points": "{{value}}pp"
    },
    "Password": {
      "Show": "Show password"
    }
  },
  "Dev": {
    "ToggleDirection": "Toggle direction"
  },
  "Dashboard": {
    "Title": "Dashboard",
    "Greeting": "Welcome back, {{name}}!",
    "GreetingNew": "Let's get started, {{name}}!",
    "Subline": "{{tenant}} | Role · {{role}}",
    "SublineRole": "Role · {{role}}",
    "Kpi": {
      "TotalDevices": "Total devices",
      "Enrolled": "Enrolled",
      "Active": "Active",
      "Locked": "Locked",
      "Up": "Up",
      "Down": "Down",
      "PointsDelta": "{{value}}pp"
    },
    "Devices": {
      "Title": "Devices",
      "Caption": "Every device sits in exactly one program",
      "ProgramSplit": "Devices by program",
      "ProgramBreakdown": "Program breakdown",
      "TotalDevices": "Total devices",
      "OfPortfolio": "{{value}} of portfolio",
      "SegmentLabel": "{{program}}: {{value}}"
    },
    "Programs": {
      "Financing": "Financing",
      "DeviceFinancing": "Device Financing",
      "SupplyChain": "Supply Chain",
      "Inventory": "Inventory"
    },
    "Services": {
      "Title": "Services",
      "Tabs": {
        "Financing": "Device Financing",
        "SupplyChain": "Supply Chain"
      },
      "BarLabel": "{{label}} {{percent}}",
      "Status": {
        "Enrolled": "Enrolled",
        "Active": "Active",
        "Locked": "Locked",
        "Released": "Released",
        "InStock": "In Stock",
        "Stolen": "Stolen",
        "Delivered": "Delivered"
      },
      "Captions": {
        "AwaitingActivation": "Awaiting activation",
        "ActiveActive": "Active · Active",
        "OnPaymentMissed": "On payment missed",
        "TermComplete": "Term complete",
        "ProtectedStock": "Protected · Stock",
        "LockedRestricted": "Locked · Restricted",
        "CompletedReleased": "Completed · Released"
      }
    },
    "Empty": {
      "Services": {
        "Title": "No service data yet",
        "Body": "Financing and supply-chain activity will appear here once you register devices."
      }
    },
    "Refresh": "Refresh dashboard",
    "LinkUnavailable": "The device list can't filter by this yet",
    "OpenInRegistry": "Open {{value}} {{label}} in the device registry",
    "LoadError": {
      "Kpi": "Couldn't load the key figures",
      "Programs": "Couldn't load devices by program",
      "Models": "Couldn't load the program breakdown",
      "ServiceTab": "Couldn't load this service"
    }
  },
  "Plans": {
    "Actions": {
      "CreatePlan": "Create plan",
      "Edit": "Edit {{name}}"
    },
    "Overview": {
      "Title": "Plans",
      "Active": "Active",
      "Enrolments": "Enrollments",
      "Devices": "Devices",
      "Delinquent": "Delinquent"
    },
    "Columns": {
      "Plan": "PLAN",
      "Service": "SERVICE",
      "Status": "STATUS",
      "Version": "VERSION",
      "Devices": "DEVICES",
      "Actions": "Actions"
    },
    "Status": {
      "PUBLISHED": "Published",
      "RETIRED": "Retired"
    },
    "Filters": {
      "All": "All",
      "Applied": "{{name}}: {{value}}",
      "ClearAll": "Clear All",
      "ClearFilter": "Clear filter: {{value}}",
      "Status": "Status",
      "SearchPlaceholder": "Search plans",
      "SearchLandmark": "Search plans",
      "Unavailable": "Filtering and search are not available yet."
    },
    "ShowingRange": "Showing {{from}}–{{to}} of {{total}}",
    "Empty": {
      "Title": "No plans yet",
      "Body": "A plan sets how a financed device is paid for: its tenure, its billing cycle and when each payment falls due. Plans you create show up here."
    },
    "Builder": {
      "DocumentTitle": "New plan",
      "Eyebrow": "Create new",
      "Title": "New plan",
      "Close": "Close plan builder",
      "Service": {
        "Heading": "Plan details",
        "Description": "A plan is a reusable package. Define the finance terms here. Devices are attached only when a device is assigned to the plan."
      },
      "Fields": {
        "Name": "Plan name",
        "NamePlaceholder": "e.g. Prepaid Weekly · 12-week",
        "NameHint": "Shown to operators when assigning devices. Keep it descriptive.",
        "Service": "Select the service",
        "ServicePlaceholder": "Choose a service",
        "TermLength": "Term length",
        "TermPlaceholder": "Select term length",
        "BillingCycle": "Billing cycle",
        "BillingPlaceholder": "Select billing cycle",
        "ServiceUnavailable": "Not available for new plans yet"
      },
      "Errors": {
        "Name": "Enter a plan name of up to 100 characters.",
        "Service": "Choose a service.",
        "ServiceRejected": "This service can’t be used for new plans. Choose another.",
        "Term": "Choose a term length.",
        "Billing": "Choose a billing cycle.",
        "Count": "Enter a whole number of 1 or more.",
        "Workflow": "Choose a workflow.",
        "WorkflowName": "Enter a name for the new workflow, up to 100 characters.",
        "NameTaken": "A plan with this name already exists.",
        "TermCount": "Enter a whole number from 1 to {{max}}.",
        "TermRejected": "This term length can’t be used. Choose another.",
        "BillingRejected": "This billing cycle can’t be used with the term length. Choose another."
      },
      "Period": {
        "Custom": "Custom",
        "Every": "Every {{period}}"
      },
      "Units": {
        "Week": "weeks",
        "Month": "months",
        "Year": "years"
      },
      "CountHint": "Whole numbers only. Minimum {{min}}.",
      "UnitLabel": "Unit",
      "Cancel": "Cancel",
      "CustomTerm": {
        "Title": "Custom term length",
        "Description": "Set how long the plan remains active after it is assigned.",
        "Count": "Duration",
        "Apply": "Apply term"
      },
      "CustomBilling": {
        "Title": "Custom billing cycle",
        "Description": "Define how often the borrower is billed.",
        "Count": "Bill every",
        "Apply": "Apply cycle",
        "FirstBill": "First bill",
        "FirstBillOptions": {
          "AfterFirstPeriod": "After the first full billing period",
          "OnActivation": "On plan activation"
        },
        "BillingDate": "Billing date",
        "BillingDateOptions": {
          "ActivationDate": "Same date as plan activation",
          "MonthEnd": "Last day of the month"
        }
      },
      "Footer": {
        "NextStep": "Enforcement workflow",
        "Review": "Review",
        "SendForReview": "Send for review",
        "PreviewPublish": "Next: preview & publish",
        "Create": "Create new plan"
      },
      "Workflow": {
        "Heading": "New plan · workflow",
        "SourceLabel": "Workflow source",
        "PickerLabel": "Workflows",
        "Sources": {
          "Existing": {
            "Title": "Use an existing workflow",
            "Description": "Recommended. Plans with different terms usually share one enforcement workflow."
          },
          "Duplicate": {
            "Title": "Duplicate an existing workflow and modify",
            "Description": "Starts from a copy. The original is untouched."
          },
          "New": {
            "Title": "Create a new workflow",
            "Description": "Opens the workflow builder. You return here when it is published."
          }
        },
        "Columns": {
          "Select": "Select",
          "Name": "Workflow",
          "Version": "Version",
          "Governs": "Already governs"
        },
        "Version": "v{{version}}",
        "Status": {
          "published": "Published",
          "draft": "Draft"
        },
        "Governs": "{{plans}} · {{devices}}",
        "GovernsNone": "—",
        "PlanCount": "{{formatted}} plans",
        "PlanCount_one": "{{formatted}} plan",
        "PlanCount_other": "{{formatted}} plans",
        "DeviceCount": "{{formatted}} devices",
        "DeviceCount_one": "{{formatted}} device",
        "DeviceCount_other": "{{formatted}} devices",
        "OpenBuilder": "Open the workflow builder",
        "BuilderComingSoon": "The workflow builder is coming soon",
        "Duplicate": {
          "NameLabel": "New workflow name",
          "NamePlaceholder": "e.g. Postpaid 12m Standard",
          "NameHint": "Starts as a draft at v1. It won’t govern this plan until you publish it.",
          "Notice": "Next you’ll open the <strong>workflow builder</strong> to edit this copy. Publishing there creates it and assigns it to this plan. <strong>{{name}} {{version}}</strong> and the devices it governs stay untouched."
        },
        "Copy": {
          "Heading": "Enforcement workflow",
          "Description": "The automated device workflow for this plan. For Supply Chain it defines how a device behaves through dispatch, delivery, theft and recovery.",
          "Notice": "Copy of <strong>{{name}} {{version}}</strong>, saved as a draft. Edit below, then publish to assign it to this plan. The original stays untouched.",
          "HeaderTitle": "{{service}} · {{name}}",
          "Meta": {
            "Template": "Template",
            "Service": "Service",
            "Reviewer": "Default review",
            "ReviewerHint": "This team member will know which devices are linked to this workflow.",
            "ReviewerHintLabel": "About the default reviewer",
            "ReviewerValue": "{{team}} - {{name}}"
          },
          "Stages": "Workflow stages",
          "Trigger": "Trigger: {{trigger}}",
          "EditStage": "Edit {{stage}}",
          "StageState": {
            "enrolled": "Enrolled",
            "active": "Active",
            "locked": "Locked",
            "released": "Released"
          }
        }
      },
      "Review": {
        "Workflow": "Workflow",
        "EditWorkflow": "Edit workflow",
        "VersionStatus": "{{version}} {{status}}",
        "Status": {
          "published": "published",
          "draft": "draft"
        },
        "StageCount": "{{formatted}} stages",
        "StageCount_one": "{{formatted}} stage",
        "StageCount_other": "{{formatted}} stages",
        "Journey": {
          "Title": "Customer Journey",
          "Description": "What the device holder experiences · communications and lock behavior by stage",
          "Eyebrow": "Communications sent at each stage"
        },
        "Checks": {
          "Heading": "Publish checks",
          "Level": {
            "ok": "Ok",
            "warn": "Warn",
            "fail": "Fail"
          }
        },
        "Offline": {
          "Heading": "Offline summary",
          "Stages": "{{formatted}} offline-capable stages",
          "Stages_one": "{{formatted}} offline-capable stage",
          "Stages_other": "{{formatted}} offline-capable stages",
          "Templates": "{{templates}} x {{locales}}",
          "TemplateCount": "{{formatted}} templates",
          "TemplateCount_one": "{{formatted}} template",
          "TemplateCount_other": "{{formatted}} templates",
          "LocaleCount": "{{formatted}} locales",
          "LocaleCount_one": "{{formatted}} locale",
          "LocaleCount_other": "{{formatted}} locales",
          "Whitelists": "{{formatted}} whitelists",
          "Whitelists_one": "{{formatted}} whitelist",
          "Whitelists_other": "{{formatted}} whitelists",
          "FailSafe": "fail-safe {{formatted}} days",
          "FailSafe_one": "fail-safe {{formatted}} day",
          "FailSafe_other": "fail-safe {{formatted}} days"
        }
      },
      "SendForReview": {
        "Title": "Are you sure you want to send for review?",
        "Body": "Your plan will be sent to <strong>{{reviewer}}</strong> for review. You’ll be notified when it’s approved or if changes are requested. The plan won’t be published until the review is complete.",
        "SaveDraft": "Save as a draft",
        "Send": "Yes, send",
        "Sent": "Plan sent to {{reviewer}} for review",
        "Saved": "Plan saved as a draft"
      },
      "Postpaid": {
        "Name": "Device Financing - Postpaid",
        "Description": "Installment enforcement. Runs active, locks on missed payment, unlocks on payment."
      },
      "BillingCycles": {
        "Daily": "Daily",
        "Weekly": "Weekly",
        "Monthly": "Monthly"
      },
      "Created": "Plan “{{name}}” created",
      "SubmitError": {
        "Title": "The plan was not created",
        "Description": "Something went wrong. Try again, and if it keeps failing, contact support with the correlation ID.",
        "Forbidden": "You don’t have permission to create plans."
      },
      "Leave": {
        "Title": "Discard this plan?",
        "Description": "You have unsaved changes. If you leave now, they will be lost.",
        "Confirm": "Discard and leave",
        "Stay": "Keep editing"
      }
    },
    "Terms": "{{term}} · {{billing}} · {{timing}}",
    "Version": "v{{version}}",
    "Unavailable": "Not available yet.",
    "NoMatch": {
      "Title": "No plans match",
      "Body": "Try a different name, or clear the status filter.",
      "Clear": "Clear filters"
    },
    "TermLength": {
      "DAY": "{{formatted}} days",
      "DAY_one": "{{formatted}} day",
      "DAY_other": "{{formatted}} days",
      "MONTH": "{{formatted}} months",
      "MONTH_one": "{{formatted}} month",
      "MONTH_other": "{{formatted}} months",
      "YEAR": "{{formatted}} years",
      "YEAR_one": "{{formatted}} year",
      "YEAR_other": "{{formatted}} years"
    },
    "BillingSingle": {
      "DAY": "Daily",
      "WEEK": "Weekly",
      "MONTH": "Monthly"
    },
    "BillingEvery": {
      "DAY": "Every {{formatted}} days",
      "DAY_one": "Every {{formatted}} day",
      "DAY_other": "Every {{formatted}} days",
      "WEEK": "Every {{formatted}} weeks",
      "WEEK_one": "Every {{formatted}} week",
      "WEEK_other": "Every {{formatted}} weeks",
      "MONTH": "Every {{formatted}} months",
      "MONTH_one": "Every {{formatted}} month",
      "MONTH_other": "Every {{formatted}} months"
    },
    "Timing": {
      "POSTPAID": "Post-paid",
      "PREPAID": "Pre-paid"
    },
    "Error": {
      "Title": "Could not load plans"
    }
  },
  "Language": {
    "Label": "Language",
    "En": "English",
    "Ar": "العربية"
  },
  "Table": {
    "Empty": "No results",
    "Previous": "Previous",
    "Next": "Next",
    "PageOf": "Page {{page}} of {{lastPage}} · {{total}} total",
    "Pagination": "Pagination",
    "GoToPage": "Go to page {{page}}",
    "GoTo": "Go to",
    "GoToLabel": "Go to page",
    "GoToNoMatch": "No matching page",
    "CursorPagination": "Pagination",
    "FirstPage": "First page",
    "Loading": "Loading results"
  },
  "A11y": {
    "SkipToContent": "Skip to main content",
    "ToggleSidebar": "Toggle sidebar",
    "Settings": "Settings",
    "Notifications": "Notifications"
  },
  "Auth": {
    "Redirecting": "Redirecting to sign-in…",
    "SignedOut": {
      "Title": "You're signed out",
      "Description": "Your session has ended. Sign in again to continue.",
      "SignInAgain": "Sign in again"
    },
    "LoopDetected": {
      "Title": "Sign-in could not be completed",
      "Description": "We tried to sign you in several times without success. Please try again shortly or contact support.",
      "Recover": "Back to sign-out"
    },
    "SessionError": {
      "Title": "Your session can't be used",
      "Description": "You're signed in, but this session cannot be used right now.",
      "ProfileFailed": "Signed in, but your profile could not be loaded. Signing out and back in may help; if it persists, contact support.",
      "RedirectFailed": "Sign-in could not be started. Please try again shortly; if it persists, contact support.",
      "SignInFailed": "Sign-in was not completed ({{error}}).",
      "ConfigUnavailable": "Unable to load authentication configuration. Please try again later.",
      "SignOut": "Sign out"
    }
  },
  "Error": {
    "NotFound": {
      "Title": "Page not found",
      "Description": "The page you are looking for does not exist.",
      "BackHome": "Back to dashboard"
    },
    "Forbidden": {
      "Title": "Access denied",
      "Description": "You don't have permission to view this page.",
      "NoRole": "Your account has no role yet. Ask a Tenant Admin to assign you one.",
      "BackHome": "Back to dashboard"
    },
    "Network": "Unable to reach the server. Check your connection.",
    "Timeout": "The request timed out. Please try again.",
    "Server": "Something went wrong on our end.",
    "NotFoundError": "That item no longer exists.",
    "Unknown": "Something went wrong.",
    "Auth": "Your session has expired. Please sign in again.",
    "Canceled": "The request was canceled.",
    "Validation": "Some fields need your attention.",
    "ForbiddenError": "You don't have permission to do that.",
    "Retry": "Retry",
    "Boundary": {
      "Root": {
        "Title": "Something went wrong",
        "Description": "The application hit an unexpected error. Reloading usually fixes it."
      },
      "Route": {
        "Title": "This page failed to load",
        "Description": "Something went wrong loading this page. Navigation still works."
      },
      "Widget": {
        "Title": "This section failed to load",
        "Description": "The rest of the page is unaffected."
      },
      "Reload": "Reload page",
      "TraceId": "Reference ID: {{traceId}}"
    },
    "Load": {
      "CorrelationId": "Correlation ID:",
      "CopyCorrelationId": "Copy correlation ID",
      "Copied": "Correlation ID copied",
      "CopyFailed": "Could not copy. Select the ID to copy it.",
      "Retry": "Try again"
    }
  },
  "Devices": {
    "Title": "Devices",
    "Subtitle": "Every device under management for this organisation.",
    "NotAvailable": "Not available",
    "Never": "Never",
    "NoState": "No policy yet",
    "NotEnrolled": "Not Enrolled",
    "Services": {
      "dfpost": "DF Post-paid",
      "sc": "Supply Chain",
      "dfpre": "DF Pre-paid",
      "sim": "SIM Control",
      "df": "Device Financing",
      "none": "Not Enrolled"
    },
    "Actions": {
      "Export": "Export",
      "Register": "Register"
    },
    "Export": {
      "Preparing": "Preparing your CSV export…",
      "Ready": "Your CSV export is ready.",
      "Failed": "The export could not be prepared.",
      "Busy": "Too many exports are running. Try again in a moment.",
      "Unavailable": "Export is not available right now. Try again later.",
      "Retry": "Try again"
    },
    "Register": {
      "Title": "Register single device",
      "Description": "Register a device by its IMEI. It appears in the registry once the service accepts it.",
      "ImeiLabel": "IMEI",
      "ImeiPlaceholder": "Enter or paste IMEI",
      "Submit": "Register device",
      "Errors": {
        "Pattern": "Enter the 15-digit IMEI, digits only."
      },
      "Failure": {
        "Luhn": {
          "Title": "This IMEI's check digit is not valid.",
          "Body": "Check the digits against the label on the device and try again."
        },
        "Duplicate": {
          "Title": "This IMEI is already registered on the platform.",
          "Body": "Search the registry to locate the existing record."
        },
        "DuplicateInTenant": {
          "Title": "IMEI is already registered in the tenant that user belongs to",
          "Body": "Search the registry to locate the existing record."
        },
        "DuplicateInPlatform": {
          "Title": "IMEI is already registered in the platform by other tenants",
          "Body": "Check the IMEI against the label on the device, or contact support if the device belongs to your organisation."
        },
        "Pattern": {
          "Title": "This IMEI was not accepted.",
          "Body": "Enter the 15-digit IMEI, digits only."
        },
        "Forbidden": {
          "Title": "You do not have permission to register devices.",
          "Body": "Ask a Tenant Admin for a role that can register devices."
        },
        "Generic": {
          "Title": "Could not register the device.",
          "Body": "Please try again."
        }
      },
      "Registered": {
        "Title": "Device registered",
        "Body": "Now searchable in the registry. Hardware details enrich at first check-in.",
        "DeviceIdLabel": "Device ID",
        "RegisterAnother": "Register another",
        "ViewDevice": "View device"
      },
      "Menu": {
        "Single": {
          "Title": "Single device",
          "Description": "Enter one device manually by IMEI"
        },
        "Bulk": {
          "Title": "Bulk upload",
          "Description": "Register many devices from a CSV file"
        }
      }
    },
    "Ago": {
      "Minutes": "{{value}}m ago",
      "Hours": "{{value}}h ago",
      "Days": "{{value}}d ago"
    },
    "Overview": {
      "Title": "Overview",
      "TotalDevices": "Total devices",
      "NeedAttention": "Need Attention",
      "Synced24h": "Synced 24h",
      "Error": "Could not load the overview",
      "Up": "Up",
      "Down": "Down"
    },
    "Tabs": {
      "Registry": "Registry",
      "Provisioning": "Provisioning Queue",
      "Audit": "Audit log"
    },
    "Columns": {
      "Select": "Select row",
      "SelectAll": "Select all rows on this page",
      "Imei": "IMEI",
      "Make": "DEVICE MAKE",
      "Model": "DEVICE MODEL",
      "Service": "SERVICE",
      "Plan": "PLAN",
      "State": "STATE",
      "Serial": "SERIAL",
      "LastSync": "LAST SYNC",
      "ViewDevice": "View device {{value}}"
    },
    "Filters": {
      "All": "All",
      "Service": "Service",
      "Plan": "Plan",
      "State": "State",
      "SearchImei": "Search IMEI",
      "SearchPlaceholder": "Search IMEI or reference..",
      "SearchLandmark": "Search the device registry",
      "SearchSerial": "Search serial",
      "ClearSearch": "Clear search",
      "Unavailable": "Filtering by this field is not available yet",
      "ClearAll": "Clear All",
      "ClearFilter": "Clear filter: {{value}}",
      "Applied": "{{name}}: {{values}}"
    },
    "Bulk": {
      "Title": "Bulk actions",
      "Close": "Close bulk actions",
      "DevicesSelected": "{{value}} devices selected",
      "Scope": "Actions apply only to devices they're valid for.",
      "StateCount": "{{value}} {{state}}",
      "Available": "Available for this selection",
      "Actions": {
        "lock": "Lock",
        "unlock": "Unlock",
        "reassignPlan": "Reassign plan",
        "export": "Export selection"
      },
      "Badge": {
        "Locked": "{{value}} locked",
        "Unlocked": "{{value}} unlocked",
        "Devices": "{{value}} devices"
      },
      "Message": {
        "Label": "Enter custom message",
        "Counter": "{{value}}/{{max}}"
      },
      "Cancel": "Cancel",
      "Save": "Save changes",
      "Confirm": {
        "Title": "Are you sure these are the right actions?",
        "Body": "The action you chose will be applied to every selected device it is valid for. Devices it does not apply to are left untouched.",
        "Continue": "Yes, continue"
      }
    },
    "ShowingRange": "Showing {{from}}–{{to}} of {{total}} devices",
    "AuditLog": {
      "Columns": {
        "Timestamp": "TIMESTAMP (UTC)",
        "Customer": "CUSTOMER",
        "Event": "EVENT",
        "Target": "TARGET",
        "Detail": "DETAIL"
      },
      "Filters": {
        "Label": "Event",
        "All": "All",
        "Event": "State change",
        "Customer": "Customer",
        "Date": "Date",
        "ShowMore": "Show {{value}} more results",
        "DateRange": "Date range",
        "From": "From",
        "To": "To",
        "SelectDate": "Select date",
        "PreviousMonth": "Previous month",
        "NextMonth": "Next month",
        "Year": "Year {{value}}",
        "Reset": "Reset",
        "ShowResults": "Show {{value}} Results",
        "Range": "{{from}}-{{to}}",
        "RangeFrom": "From {{from}}",
        "SearchPlaceholder": "Search by IMEI, batch #, case #, or user…",
        "SearchLandmark": "Search the audit log"
      },
      "Categories": {
        "COMMAND": "Command",
        "CONFIGURATION": "Policy Change",
        "ROLE_GRANT": "Role & Access",
        "DELEGATION": "Delegation",
        "CREDENTIAL": "Credential",
        "TENANT_LIFECYCLE": "Tenant lifecycle",
        "REGISTRATION": "Registration",
        "ENROLMENT": "Enrolment",
        "AUTHENTICATION": "Sign-in"
      },
      "Events": {
        "Lock": "Lock",
        "AutoLock": "Auto-lock",
        "Unlock": "Unlock",
        "AutoUnlock": "Auto-unlock",
        "ApiCall": "API call"
      },
      "ActorTypes": {
        "USER": "Portal user",
        "MACHINE": "API client",
        "POLICY": "Policy engine",
        "SYSTEM": "System",
        "INTERNAL": "Cenorion staff"
      },
      "TargetTypes": {
        "DEVICE": "Device",
        "ENROLMENT": "Enrolment",
        "USER": "User account",
        "ROLE": "Role",
        "DELEGATION": "Delegation",
        "MACHINE_IDENTITY": "Machine identity",
        "TENANT": "Tenant",
        "WORKFLOW": "Workflow"
      },
      "Actions": {
        "Lock": "Lock applied",
        "Unlock": "Unlock applied",
        "Register": "Device registered",
        "RegisterBulk": "Devices submitted to provisioning",
        "CommandDelivered": "Command delivered to the device",
        "EnrolmentCreate": "Service assigned",
        "WorkflowPublish": "Workflow published",
        "ConfigUpdate": "Configuration updated",
        "TenantActivate": "Tenant activated",
        "RoleGrant": "Role assigned",
        "SignIn": "Signed in",
        "DelegationCreate": "Delegation granted",
        "SecretRotate": "API secret rotated",
        "Unknown": "{{value}}"
      },
      "Rejected": "Rejected",
      "Reasons": {
        "CommandAlreadyPending": "A command is already pending for this device",
        "AlreadyApplied": "The device is already in this state",
        "Forbidden": "Not permitted for this role",
        "DeviceAlreadyRegistered": "The device is already registered",
        "ServiceNotEnabled": "The service is not enabled for this tenant",
        "InvalidCredentials": "Invalid credentials",
        "Unknown": "Refused by the platform ({{value}})"
      },
      "ShowingRange": "Showing {{from}}–{{to}} of {{total}}",
      "Empty": {
        "NoEvents": {
          "Title": "No events in the last 7 days",
          "Body": "Actions on devices, users and settings are recorded here. Pick an earlier date range to look further back."
        },
        "NoMatches": {
          "Title": "No events match these filters",
          "Body_one": "No audit events match the <strong>{{count}} filter</strong> applied. Try removing it to widen the results.",
          "Body_other": "No audit events match the <strong>{{count}} filters</strong> applied. Try removing one to widen the results.",
          "ClearFilters": "Clear filters"
        }
      },
      "Error": {
        "Title": "Could not load the audit log",
        "Retry": "Try again"
      }
    },
    "Error": {
      "Title": "Could not load devices",
      "Retry": "Try again"
    },
    "Empty": {
      "Provisioning": {
        "Title": "Provisioning Queue",
        "Body": "Devices queued for provisioning will appear here."
      },
      "Audit": {
        "Title": "Audit log",
        "Body": "Every device state change is recorded here."
      },
      "Registry": {
        "Body": "No device matches this filter."
      },
      "NoDevices": {
        "Title": "No devices yet",
        "Body": "Register your first device to start tracking enrolment and enforcement across your portfolio. Add one at a time, or bulk upload a CSV.",
        "RegisterSingle": "Register single device",
        "BulkUpload": "Bulk upload"
      },
      "NoMatches": {
        "Title": "No devices match these filters",
        "Body_one": "No devices match the <strong>{{count}} filter</strong> applied. Try removing it to widen the results.",
        "Body_other": "No devices match the <strong>{{count}} filters</strong> applied. Try removing one to widen the results.",
        "ClearFilters": "Clear filters"
      },
      "NoSearchMatches": {
        "Title": "No devices match your search",
        "Body": "No device matches <strong>{{query}}</strong>. Check the IMEI or serial number and try again.",
        "ClearSearch": "Clear search"
      }
    },
    "Lock": {
      "Success": "Lock command sent. Waiting for the device to acknowledge.",
      "Errors": {
        "InFlight": "A lock command is already in flight for this device.",
        "NotFound": "This device is no longer in the registry.",
        "Forbidden": "You do not have permission to lock this device.",
        "Generic": "The lock command could not be sent. Try again."
      }
    },
    "Unlock": {
      "Success": "Unlock command sent. Waiting for the device to acknowledge.",
      "Errors": {
        "InFlight": "A command is already in flight for this device.",
        "NotFound": "This device is no longer in the registry.",
        "Forbidden": "You do not have permission to unlock this device.",
        "Generic": "The unlock command could not be sent. Try again."
      }
    },
    "AssignService": {
      "Title": "Assign service",
      "Description": "This device is in inventory and not yet enrolled in any service. Assign it directly — there is no service to hand over from.",
      "DeviceLabel": "Device",
      "NotEnrolled": "Not enrolled · no current service",
      "ServiceLabel": "Assign to service",
      "ServicePlaceholder": "Select a service…",
      "ServiceOptions": {
        "sc": {
          "Name": "Supply Chain",
          "Description": "Protect devices in the supply chain until handover"
        },
        "dfpost": {
          "Name": "Device Financing (Post-paid)",
          "Description": "Plans and workflows for Post-paid"
        },
        "dfpre": {
          "Name": "Device Financing (Pre-paid)",
          "Description": "Plans and workflows for Pre-paid"
        }
      },
      "PlanLabel": "Plan",
      "PlanPlaceholder": "Select plan…",
      "WorkflowLabel": "Workflow",
      "WorkflowPlaceholder": "Select workflow…",
      "WorkflowOption": "{{name}} · v{{version}}",
      "TermLength": "Term length",
      "BillingCycle": "Billing cycle",
      "TermHintEmpty": "Shown once a plan is selected.",
      "TermHintSet": "Set by the selected plan.",
      "NoPlanOrWorkflow": {
        "Title": "Create a plan and workflow first",
        "Body": "There’s no published Device Financing (Post-paid) plan or workflow yet, so this service can’t be assigned. A Tenant Admin can publish them in Plans & contracts.",
        "Action": "Go to Plans & contracts"
      },
      "States": {
        "ENROLLED": "Enrolled",
        "PROTECTED": "Protected"
      },
      "SuccessDialog": {
        "Title": "Service assigned",
        "Body": {
          "ENROLLED": "{{device}} is now enrolled in {{service}}. The plan starts at the device's first check-in.",
          "PROTECTED": "{{device}} is now protected in {{service}}."
        },
        "Service": "Service",
        "Plan": "Plan",
        "Workflow": "Workflow",
        "State": "State",
        "Close": "Close",
        "ViewDevice": "View device"
      },
      "Submit": "Assign service",
      "Errors": {
        "Forbidden": "You do not have permission to assign a service to this device.",
        "NotFound": "No device is registered with this IMEI.",
        "Title": "Service not assigned",
        "AlreadyAssigned": "This device already has a service that prevents this assignment.",
        "AlreadyFinanced": "This device is already financed in this tenant.",
        "StateChanged": "This device is now {{state}}, so a service can no longer be assigned to it.",
        "PlanUnavailable": "The selected plan is no longer available. Choose another plan.",
        "WorkflowUnavailable": "The selected workflow is no longer available. Choose another workflow.",
        "ServiceDisabled": "This service is not available for your organisation.",
        "Generic": "The service could not be assigned. Try again."
      }
    },
    "ServiceHandover": {
      "Title": "Service handover",
      "Description": "Hand this device over from Supply Chain to Device Financing. Enrolment into financing releases it from Supply Chain in the same step.",
      "FromLabel": "From",
      "ServiceLabel": "Hand over to",
      "ServiceHint": "Choose a service to see its plans and workflows. No service is selected by default.",
      "PostpaidActivationNote": "After handover, the Post-paid enrolment waits for activation on the device.",
      "Submit": "Hand over",
      "NoPrepaidWorkflow": {
        "Title": "Create a Pre-paid plan and workflow first",
        "Body": "There’s no Pre-paid workflow yet, so this handover can’t be confirmed. Set one up in Plans & contracts, then come back.",
        "Action": "Go to Plans & contracts"
      },
      "SuccessDialog": {
        "Title": "Handover complete",
        "Body": {
          "ENROLLED": "{{device}} has been released from {{from}} and handed over to {{service}}. It waits for activation on the device.",
          "PROTECTED": "{{device}} has been released from {{from}} and handed over to {{service}}."
        },
        "From": "From",
        "To": "To",
        "States": {
          "ENROLLED": "Pending activation",
          "PROTECTED": "Protected"
        }
      }
    },
    "OfflineUnlockCode": {
      "Title": "Generate Offline Pin Unlock Code · Step {{step}} of {{total}}",
      "LastSeen": "last seen {{ago}}",
      "UnlocksTo": "Unlocks to",
      "GoodStanding": "Good Standing",
      "ValidUntil": "Valid until",
      "ChallengeKey": {
        "Label": "Challenge key",
        "Placeholder": "e.g. 407 182 3596",
        "Hint": "Shown on the locked device under “Offline unlock”. Ask the holder to read it out.",
        "Invalid": "Enter the 10 digits exactly as the locked phone shows them.",
        "Required": "Enter the challenge key."
      },
      "Reason": {
        "Label": "Reason",
        "Placeholder": "Explain why you’re issuing an offline unlock code, e.g. payment confirmed but the device can’t reach the platform.",
        "Hint": "Kept in the audit record only. It isn’t shown in the code history.",
        "Counter": "{{value}} / {{max}}",
        "Required": "Enter a reason.",
        "TooLong": "Keep the reason to {{max}} characters or fewer."
      },
      "Reasons": {
        "PAYMENT_CONFIRMED_DEVICE_UNREACHABLE": "Payment confirmed, phone can’t sync",
        "DEVICE_OFFLINE_NO_PAYMENT_ISSUE": "Phone offline, no payment issue",
        "OTHER": "Other",
        "UNKNOWN": "Other reason"
      },
      "Recap": {
        "ChallengeKey": "Challenge key <ltr>{{key}}</ltr>",
        "Reason": "Reason: {{reason}}"
      },
      "Code": "Code",
      "Generating": "Generating code…",
      "Cancel": "Cancel",
      "Generate": "Generate code",
      "GenerateNew": "Generate New Code",
      "RegenerateNote": "“Generate new code” returns to step 1 to enter a new challenge key.",
      "Copy": "Copy Code",
      "Copied": "Code copied to the clipboard.",
      "CopyFailed": "The code could not be copied. Select it and copy it manually.",
      "PreviouslyIssued": "PREVIOUSLY ISSUED",
      "Columns": {
        "Time": "TIME",
        "User": "USER",
        "Status": "STATUS"
      },
      "Statuses": {
        "ISSUED": "Issued",
        "REDEEMED": "Unlock",
        "FAILED": "Failed",
        "LOCKED_OUT": "Locked out",
        "EXPIRED_UNUSED": "Expired",
        "REVOKED": "Revoked",
        "UNKNOWN": "Unknown"
      },
      "RepeatNotice": "This challenge already had a code, so this is the same code. It still counts toward your limit.",
      "Expired": {
        "Title": "This code has expired",
        "Body": "Ask the holder for a new challenge key, then generate a new code."
      },
      "Errors": {
        "Forbidden": "Your role can’t generate offline unlock codes.",
        "SupervisorRequired": "A supervisor has to approve this code. Escalate it, then try again once it’s approved.",
        "NotFound": "This device no longer exists in your tenant.",
        "KeyNotProvisioned": "This phone has no offline unlock key yet, so no code can unlock it.",
        "ChallengeExpired": "This challenge has expired. Ask the holder for a new challenge key.",
        "Released": "This device has been released, so offline unlock no longer applies.",
        "NotEnrolled": "This device has no current enrolment, so no code can be issued.",
        "Throttled": "You’ve reached the limit for offline unlock codes. Try again later.",
        "ThrottledWait": "You’ve reached the limit for offline unlock codes. Try again in {{seconds}} s.",
        "Unavailable": "The service is busy. Nothing was used up, so it’s safe to try again shortly.",
        "UnavailableWait": "The service is busy. Nothing was used up; try again in {{seconds}} s.",
        "Generic": "The code could not be generated. Try again."
      },
      "History": {
        "Loading": "Loading issued codes…",
        "Error": "The issued codes could not be loaded.",
        "Retry": "Retry",
        "Empty": "No codes have been issued for this device."
      }
    },
    "Detail": {
      "Title": "Selected device",
      "Close": "Close device details",
      "CommandBadge": {
        "PendingLock": "PENDING LOCK",
        "PendingUnlock": "PENDING UNLOCK",
        "AwaitingResponse": "AWAITING DEVICE RESPONSE"
      },
      "Identifier": "IMEI {{imei}}",
      "Actions": {
        "QuickAction": "Quick Action",
        "PinUnlock": "Pin Unlock",
        "AssignService": "Assign Service",
        "AssignServiceNoImei": "Assigning a service needs the device's IMEI",
        "ServiceHandover": "Service Handover",
        "LockDevice": "Lock Device",
        "LockConfirm": {
          "Title": "Lock device",
          "Body": "This restricts the device under the tenant's enforcement mode and takes effect on the next check-in. The holder is notified in-app.",
          "DeviceLabel": "Device",
          "Posture": "currently unlocked",
          "ReasonLabel": "Message for the record",
          "ReasonPlaceholder": "Explain the reason for this action. Stored on the policy log and the device history, and visible to other operators.",
          "ReasonHint": "A stated reason and note are required — a command without one is rejected with a policy-log entry.",
          "ReasonRequired": "Enter a reason for locking.",
          "Counter": "{{value}}/{{max}}",
          "Continue": "Lock device"
        },
        "UnlockDevice": "Unlock Device",
        "UnlockConfirm": {
          "Title": "Unlock device",
          "Body": "This lifts the restriction and takes effect on the next check-in. The holder is notified in-app.",
          "DeviceLabel": "Device",
          "Posture": "currently locked",
          "ReasonLabel": "Message for the record",
          "ReasonPlaceholder": "Explain the reason for this action. Stored on the policy log and the device history, and visible to other operators.",
          "ReasonHint": "A stated reason and note are required — a command without one is rejected with a policy-log entry.",
          "ReasonRequired": "Enter a reason for unlocking.",
          "Counter": "{{value}}/{{max}}",
          "Continue": "Unlock device"
        },
        "NotAvailableYet": "This action is not available yet"
      },
      "Tabs": {
        "Summary": "Summary",
        "Device": "Device",
        "Connectivity": "Connectivity",
        "Security": "Security",
        "History": "History"
      },
      "Current": {
        "Plan": "Plan",
        "Workflow": "Workflow",
        "Term": "Term",
        "DueBy": "Due By",
        "FirstSeen": "First Seen",
        "LastSeen": "Last Seen",
        "TermValue": "{{from}} - {{to}}"
      },
      "Build": {
        "Section": "IDENTITY & BUILD",
        "Manufacturer": "Manufacturer",
        "SerialNumber": "Serial Number",
        "AndroidOs": "Android OS · SDK",
        "SdkValue": "SDK {{value}}",
        "Timezone": "Timezone",
        "Model": "Model",
        "Imei2": "IMEI 2",
        "AppVersion": "App Version"
      },
      "Security": {
        "Section": "SECURITY"
      },
      "Enrolments": {
        "Section": "ENROLMENT HISTORY",
        "ViewMore": "View more",
        "Present": "present",
        "OpenHistory": "Open the device history"
      },
      "Enrolment": {
        "Section": "ENROLMENT HISTORY",
        "When": "WHEN",
        "Origin": "ORIGIN",
        "Event": "EVENT",
        "Origins": {
          "SERVER": "Server",
          "DEVICE": "Device"
        },
        "Categories": {
          "ENFORCEMENT": "Enforcement",
          "MESSAGES": "Messages",
          "BINDINGS": "Bindings",
          "AGENTS": "Agents"
        },
        "ClearAll": "Clear all",
        "Filter": "Filter events",
        "FilterActive": "Filter events ({{value}} applied)",
        "AllCategories": "All",
        "LoadError": "Couldn't load the device history",
        "Empty": {
          "Title": "No history yet",
          "Body": "Commands, enrolment changes and policy decisions on this device will appear here."
        },
        "NoMatches": {
          "Title": "No events match these filters",
          "Body_one": "No events match the <strong>{{count}} filter</strong> applied. Try removing it to widen the results.",
          "Body_other": "No events match the <strong>{{count}} filters</strong> applied. Try removing one to widen the results.",
          "ClearFilters": "Clear filters"
        }
      },
      "Loading": "Loading device details",
      "Error": {
        "Title": "Could not load this device"
      },
      "Connectivity": {
        "Section": "CONNECTIVITY",
        "LastSeen": "Last Seen"
      },
      "OfflineFailSafe": {
        "Label": "Offline failsafe",
        "Triggered": "Triggered",
        "NotTriggered": "Not triggered"
      },
      "AwaitingFirstCheckIn": "Awaiting first check-in",
      "PendingCommand": {
        "LOCK": {
          "Title": "Lock sent {{ago}} by {{name}} · awaiting device acknowledgement",
          "TitleNoIssuer": "Lock sent {{ago}} · awaiting device acknowledgement",
          "Body": "The device hasn't confirmed the lock yet, so it's still unlocked. It will lock at its next check-in once it's online. If it stays offline, the command remains queued; resend it from Quick Action if it hasn't gone through."
        },
        "UNLOCK": {
          "Title": "Unlock sent {{ago}} by {{name}} · awaiting device acknowledgement",
          "TitleNoIssuer": "Unlock sent {{ago}} · awaiting device acknowledgement",
          "Body": "The device hasn't confirmed the unlock yet, so it's still locked. It will unlock at its next check-in once it's online. If it stays offline, the command remains queued; resend it from Quick Action if it hasn't gone through."
        }
      },
      "NoAccess": "You don't have access to this information"
    },
    "BulkRegister": {
      "Title": "Bulk register devices",
      "DeviceFileLabel": "Upload device list",
      "Dropzone": {
        "Prompt": "Drag a CSV here, or",
        "Hint": "One device per row · CSV against the published column schema",
        "AriaLabel": "Upload a CSV of devices. Drag and drop a file here, or activate to browse.",
        "Browse": "browse"
      },
      "File": {
        "Remove": "Remove file",
        "Rows": "{{formatted}} devices",
        "Rows_one": "{{formatted}} device",
        "Rows_other": "{{formatted}} devices"
      },
      "Uploading": "Uploading…",
      "Actions": {
        "DownloadTemplate": "Download CSV template",
        "Register": "Register",
        "RegisterCount": "Register {{formatted}} devices",
        "RegisterCount_one": "Register {{formatted}} device",
        "RegisterCount_other": "Register {{formatted}} devices",
        "Done": "Done",
        "ViewQueue": "View provisioning queue"
      },
      "Errors": {
        "mime": {
          "Title": "Not a CSV file",
          "Body": "Choose a file with a .csv extension."
        },
        "size": {
          "Title": "File is too large",
          "Body": "Choose a CSV within the size limit."
        },
        "header": {
          "Title": "Missing imei column",
          "Body": "The header row needs an imei column. Download the template to check."
        },
        "empty": {
          "Title": "No devices in this file",
          "Body": "The file has only a header row. Add at least one device row, then choose it again."
        },
        "file_too_large": {
          "Title": "File is too large",
          "Body": "The server rejected the file for exceeding the size limit."
        },
        "unsupported_media_type": {
          "Title": "Unsupported file type",
          "Body": "Only CSV files are accepted."
        },
        "upload": {
          "Title": "Upload failed",
          "Body": "The file could not be uploaded. Check your connection and try again."
        },
        "server": {
          "Title": "Something went wrong",
          "Body": "The registration could not be started. Try again."
        },
        "too_many_uploads": {
          "Title": "Too many uploads in progress",
          "Body": "Your organisation already has the maximum number of bulk uploads running. Wait for one to finish, then try again."
        },
        "already_started": {
          "Title": "Upload already started",
          "Body": "This upload has already started. Start a new upload to send another file."
        },
        "unavailable": {
          "Title": "Bulk upload unavailable",
          "Body": "Bulk upload is not available right now. Try again later."
        },
        "upload_rejected": {
          "Title": "Upload refused",
          "Body": "The upload link expired or the file changed after it was chosen. Choose the file again and retry."
        }
      },
      "Notes": {
        "Requirements": "Each row needs an IMEI. IMEI2, serial and enrolment are optional.",
        "Count": "Count is the total rows in the file. Valid vs. rejected is resolved once processing runs — you'll see it in the Provisioning Queue."
      },
      "Queued": {
        "Title": "Devices queued for registration",
        "Body": "Your devices have been sent to the provisioning queue and are registering in the background. Large files can take a few minutes — you don't need to wait here. We'll notify you when it's done. Any rows that can't be registered will be listed in the queue with a reason."
      }
    },
    "ProvisioningQueue": {
      "Overview": {
        "InProgress": "In Progress",
        "Completed": "Completed",
        "NeedAttention": "Need Attention",
        "Failed": "Failed",
        "LoadError": "Could not load the provisioning overview",
        "FailedBreakdown": {
          "Title": "Failed breakdown",
          "Item": "{{count}} {{label}}",
          "DuplicateExisting_one": "{{formatted}} duplicate registration",
          "DuplicateExisting_other": "{{formatted}} duplicate registrations",
          "Retry": "Retry applies to {{count}}; the rest need a decision.",
          "NotEnforceable": "These {{count}} devices are not enrolled and not enforceable."
        }
      },
      "Filter": {
        "State": "State",
        "All": "All",
        "InProgress": "In progress",
        "Failed": "Failed",
        "Completed": "Completed",
        "SearchPlaceholder": "Search by IMEI, batch #, case #, or user…",
        "SearchLabel": "Search the provisioning queue"
      },
      "Table": {
        "Batch": "Batch",
        "Devices": "Devices",
        "Status": "Status",
        "TimeInQueue": "Time in queue",
        "TimeInQueueHint": "How long this batch has been waiting in the queue since it was submitted.",
        "Action": "Action",
        "Review": "Review",
        "NoAction": "—",
        "BatchNumber": "#{{number}}",
        "ViewBatch": "View batch {{name}}"
      },
      "ShowingRange": "Showing {{from}}–{{to}} of {{total}}",
      "LoadError": "Could not load the provisioning queue",
      "Status": {
        "InProgress": "In progress",
        "Completed": "Completed",
        "Failed": "Failed",
        "ReasonsLabel": "Reason",
        "ReasonLine": "{{reason}} - {{count}} devices"
      },
      "Reason": {
        "ImeiFormat": "Invalid IMEI length - not 15 digits",
        "ImeiLuhn": "Invalid IMEI - check digit does not match",
        "MissingIdentifier": "Missing IMEI"
      },
      "Detail": {
        "Meta": {
          "Started": "Started",
          "Finished": "Finished",
          "UploadedBy": "Uploaded by",
          "SourceFile": "Source file"
        },
        "Progress": {
          "TotalInBatch": "Total in batch",
          "Completed": "Completed",
          "Failed": "Failed",
          "InProgress": "In progress",
          "Counting": "Counting rows…",
          "BarLabel": "Upload progress"
        },
        "Banner": {
          "Failed": {
            "Title": "Fix and re-upload the {{count}} failed devices",
            "StepDownload": "Download failed CSV",
            "StepCorrect": "Correct the flagged rows",
            "StepUpload": "Upload as a new batch",
            "ResultsNotReady": "The failed devices file isn't ready yet. Try again in a moment."
          },
          "InProgress": {
            "Title": "Batch is in progress",
            "Body": "Wait until fully completed before any action can be done."
          },
          "Completed": {
            "Title": "Provisioning completed successfully",
            "Body": "All devices were processed and registered successfully. You can review the batch results or export the final report."
          }
        },
        "FailuresByReason": "Failures by reason",
        "Close": "Close batch details",
        "PanelTitle": "Selected batch",
        "BatchTitle": "Batch #{{number}}",
        "ReUpload": "Re-Upload",
        "ExportFailedReport": "Export failed report"
      }
    }
  },
  "Configuration": {
    "DeviceHolder": {
      "Title": "Device Holder Settings",
      "Description": "Privacy Disclosure content, support contacts and offline controls for device holders.",
      "Impact": "Affects every device",
      "Subline": "Privacy Disclosure content, support contacts and offline controls for device holders.",
      "TabsLabel": "Device holder settings",
      "Tabs": {
        "PrivacyDisclosure": "Privacy Disclosure Content",
        "SupportContacts": "Support Contacts",
        "OfflineControls": "Offline Controls",
        "PaymentOptions": "Payment Options"
      },
      "ComingSoon": "Coming soon",
      "Privacy": {
        "Title": "Privacy Disclosure Content",
        "Description": "The agreement every device holder must accept the first time their device starts. There is no decline option.",
        "LastUpdatedBy": "Last updated {{date}} by {{name}}",
        "LastUpdated": "Last updated {{date}}",
        "LastUpdatedNotSet": "Last updated — Not set",
        "Edit": "Edit",
        "Status": {
          "Set": "Set",
          "NotSet": "Not set"
        },
        "Document": {
          "Title": "Device Holder Agreement",
          "Hint": "Should cover the End User License Agreement (EULA), Privacy Policy, and Terms and Conditions.",
          "EditHint": "Cover the End User License Agreement (EULA), Privacy Policy, and Terms and Conditions in this one document.",
          "Updated": "Updated {{date}}"
        },
        "ViewNote": "Holders see this agreement the first time their device starts and must select Accept to continue. Acceptance is recorded with the date and time on the device’s History tab. Holders can read it at any time in Settings › Legal, including offline.",
        "EditNote": "Holders who have already accepted won’t be asked to accept again when you change this agreement. Re-acceptance comes with versioning after MVP.",
        "Placeholder": "Enter the End User License Agreement, Privacy Policy, and Terms and Conditions that needs end user consent",
        "Supports": "Supports headings, bold, italic, underline, lists and https links. Images, tables and scripts are removed on paste.",
        "Count": "{{count}} / {{max}} characters",
        "Errors": {
          "InsecureLink": "Links must use https. Change “{{href}}” to an https link.",
          "TooLong": "The agreement is over {{max}} characters. Shorten it to save."
        },
        "Footer": {
          "Unchanged": "Save changes is enabled once you make a change.",
          "Invalid": "Fix the highlighted error to save.",
          "Empty": "Enter the agreement to save."
        },
        "Cancel": "Cancel",
        "Save": "Save changes",
        "Saved": "Device Holder Agreement saved",
        "SaveFailed": {
          "Title": "The agreement could not be saved",
          "Description": "Your edits are kept. Select Save changes to try again."
        },
        "LoadFailed": "The Device Holder Agreement could not be loaded",
        "Toolbar": {
          "Label": "Formatting",
          "Heading1": "Heading 1",
          "Heading2": "Heading 2",
          "Heading3": "Heading 3",
          "Bold": "Bold",
          "Italic": "Italic",
          "Underline": "Underline",
          "BulletList": "Bulleted list",
          "OrderedList": "Numbered list",
          "Link": "Link"
        },
        "Link": {
          "Label": "Link address",
          "Apply": "Apply",
          "Remove": "Remove link",
          "Insecure": "Links must use https.",
          "Invalid": "Enter a web address, for example https://example.com."
        },
        "History": {
          "Title": "Version history",
          "Description": "Each published change will be versioned. When the version changes, holders re-accept on next open and the trail is kept.",
          "Columns": {
            "Version": "Version",
            "Status": "Status",
            "Date": "Date"
          },
          "Current": "Published — current",
          "Earlier": "Earlier versions appear here once versioning ships",
          "VersionLabel": "v{{version}}"
        },
        "Stale": {
          "Title": "The agreement changed while you were editing",
          "Description": "Someone else saved the agreement. Load the latest version to see their change, then make your edits again. Your unsaved edits will be replaced.",
          "Reload": "Load latest",
          "Reloaded": "Latest version loaded. Make your edits again and save.",
          "ReloadFailed": "Couldn’t load the latest version. Try again."
        },
        "Refused": {
          "Title": "The platform refused this agreement",
          "Description": "Check that every link uses https and the agreement is within the character limit, then try again."
        }
      },
      "Offline": {
        "Title": "Offline Controls",
        "Description": "Decide how devices behave when they can’t reach the platform. Changes reach each device at its next check-in.",
        "LastUpdatedBy": "Last updated {{date}} by {{name}}",
        "LastUpdatedNotSet": "Last updated — Not set",
        "Edit": "Edit",
        "Off": "Off",
        "Lock": {
          "Title": "Lock devices that stay offline",
          "Description": "Fully restrict a device that can’t reach the platform for too long. Payments, emergency calls, whitelisted apps and numbers, and support stay available.",
          "Hours": "{{hours}} hours",
          "Hours_one": "{{hours}} hour",
          "Hours_other": "{{hours}} hours",
          "HoursCaption": "Allowed offline time",
          "Field": "Allowed offline time",
          "Unit": "Unit",
          "UnitHours": "Hours",
          "Help": "Devices that cannot reach the platform for longer than this are fully restricted until they reconnect.",
          "Limit": "Platform limit: {{min}}–{{max}} hours",
          "OutOfRange": "Enter a whole number between {{min}} and {{max}} hours."
        },
        "Unlock": {
          "Title": "Limit offline unlock duration",
          "Scope": "Device Financing (Post-paid) only",
          "Description": "Set how long an offline PIN unlock lasts before the device must reconnect.",
          "Field": "Offline unlock validity period",
          "HoursCaption": "Offline unlock validity period",
          "Help": "After an offline PIN unlock, the device must reconnect within this time or it locks again."
        },
        "Note": "Offline time is counted from the last time the platform confirmed the device, so changing the device’s date, time or time zone doesn’t affect it. A device that’s already locked stays locked.",
        "Footer": {
          "Invalid": "Fix the highlighted field to save.",
          "Missing": "Enter the allowed offline time to save.",
          "Unchanged": "Save changes is enabled once you make a change.",
          "MissingUnlock": "Enter the offline unlock validity period to save."
        },
        "Cancel": "Cancel",
        "Save": "Save changes",
        "Saved": "Offline controls saved",
        "LoadFailed": "Couldn’t load offline controls",
        "Summary": {
          "On": "On · {{hours}} hours",
          "On_one": "On · {{hours}} hour",
          "On_other": "On · {{hours}} hours",
          "Change": "{{from}} → {{to}}"
        },
        "Confirm": {
          "Title": "Save offline controls?",
          "Body": "This change affects every device. Each device picks up the new values at its next check-in. Until then, devices keep the settings they already have.",
          "SummaryLabel": "Changes",
          "LockLine": "Lock devices that stay offline: {{value}}",
          "UnlockLine": "Limit offline unlock duration: {{value}}"
        },
        "SaveFailed": {
          "Title": "Couldn’t save offline controls",
          "Description": "Something went wrong. Your edits are still here, so try again."
        },
        "Refused": {
          "Title": "The platform refused these values",
          "Description": "Its limits may have changed. Check the allowed range and try again."
        },
        "Stale": {
          "Title": "These settings changed while you were editing",
          "Description": "Someone else saved offline controls. Load the latest version, then save again. Your edits stay here.",
          "Reload": "Load latest",
          "Reloaded": "Latest settings loaded. Review your edits and save again.",
          "ReloadFailed": "Couldn’t load the latest settings. Try again."
        },
        "Required": "Enter a whole number of hours."
      },
      "Discard": {
        "Title": "Discard unsaved changes?",
        "Body": "Your edits to {{section}} haven’t been saved. If you leave now, they’ll be lost.",
        "Keep": "Keep editing",
        "Confirm": "Discard changes"
      },
      "Support": {
        "Title": "Support Contacts",
        "Description": "Shown to device holders on the Help screen and on lock screens. The phone number can be called even when the device is locked.",
        "LastUpdatedBy": "Last updated {{date}} by {{name}}",
        "LastUpdated": "Last updated {{date}}",
        "LastUpdatedNotSet": "Last updated — Not set",
        "Edit": "Edit",
        "NotSet": "Not set",
        "ViewNote": "On the device the phone number is tap-to-call and the email is tap-to-email, with support hours below when set. If no contacts are set, the support area is hidden rather than shown empty.",
        "Fields": {
          "Phone": "Support phone number",
          "CountryCode": "Country code",
          "Email": "Support email address",
          "EmailPlaceholder": "help@example.com",
          "Hours": "Support hours",
          "HoursHint": "Optional. Shown to device holders below the contacts, up to 100 characters.",
          "HoursPlaceholder": "e.g. Mon–Sat, 8:00 am – 6:00 pm"
        },
        "Errors": {
          "PhoneRequired": "Enter a support phone number.",
          "PhoneInvalid": "Enter a valid number for {{country}} (+{{dialCode}}), e.g. {{example}}.",
          "EmailRequired": "Enter a support email address.",
          "EmailInvalid": "Enter a valid email address, e.g. help@example.com.",
          "HoursTooLong": "Keep support hours to {{count}} characters."
        },
        "Footer": {
          "Unchanged": "Save changes is enabled once you make a change.",
          "Invalid_one": "Fix the highlighted field to save.",
          "Invalid_other": "Fix the {{count}} highlighted fields to save."
        },
        "Cancel": "Cancel",
        "Save": "Save changes",
        "Saved": "Support contacts saved",
        "SaveFailed": {
          "Title": "We couldn’t save your changes",
          "Description": "Your edits are still here. Try again, or share the correlation ID with platform support if it keeps happening.",
          "Retry": "Retry"
        },
        "Stale": {
          "Title": "These contacts changed while you were editing",
          "Description": "Someone else saved the tenant settings. Load the latest version, then save again. Your edits stay here.",
          "Reload": "Load latest",
          "Reloaded": "Latest settings loaded. Review your edits and save again.",
          "ReloadFailed": "Couldn’t load the latest settings. Try again."
        },
        "Refused": {
          "Title": "The platform refused these contacts",
          "Description": "Check the phone number and email address, then try again."
        },
        "LoadFailed": "The support contacts could not be loaded"
      }
    },
    "Title": "App customization",
    "Subline": "Personal account information and preferences. These settings apply to you only.",
    "Sections": {
      "Organisation": "Organisation · Tenant admin",
      "AppSettings": "App settings"
    },
    "UsersAndRoles": {
      "Title": "Users and roles",
      "Description": "Manage users, roles, and permissions to control who can access and manage different parts of the platform.",
      "Impact": "Affects access",
      "Subline": "Manage users, assign roles, and control access across the platform based on each role’s permissions.",
      "Tabs": {
        "RolesAndPermissions": "Roles & permissions",
        "Users": "Users"
      },
      "Users": {
        "Columns": {
          "User": "USER",
          "Email": "EMAIL",
          "Role": "ROLE",
          "Status": "STATUS",
          "LastActive": "LAST ACTIVE",
          "Actions": "Actions"
        },
        "Title": "Users",
        "ComingSoon": "This section is still being implemented and will be available soon.",
        "Summary": "{{value}} users",
        "SummaryPending": "{{value}} users · {{pending}} pending",
        "ShowingRange": "Showing {{from}}–{{to}} of {{total}} users",
        "Filters": {
          "Role": "Role",
          "Status": "Status",
          "AllRoles": "All roles",
          "AllStatuses": "All statuses",
          "SearchPlaceholder": "Search by name or email…",
          "SearchLandmark": "Search the tenant's users"
        },
        "Status": {
          "Active": "Active",
          "Pending": "Pending invite",
          "Deactivated": "Deactivated",
          "Unknown": "This status is not described yet"
        },
        "You": "(you)",
        "Roles": {
          "None": "No role assigned"
        },
        "LastActive": {
          "JustNow": "Just now",
          "Unknown": "No activity recorded",
          "NotApplicable": "Not applicable",
          "Invited": "Invited {{when}}",
          "Deactivated": "Deactivated {{when}}",
          "Expires": "expires {{when}}",
          "Expired": "expired {{when}}",
          "InvitedExpiry": "{{invited}} · {{expiry}}"
        },
        "Actions": {
          "Open": "Actions for {{name}}",
          "ChangeRole": "Change role",
          "ViewActivity": "View activity / audit log",
          "Deactivate": "Deactivate",
          "ResendInvite": "Resend invite",
          "CopyInviteLink": "Copy invite link",
          "CancelInvite": "Cancel invite",
          "Reactivate": "Reactivate",
          "RemovePermanently": "Remove permanently",
          "DeactivateConfirm": {
            "Title": "Deactivate this user?",
            "Body": "{{name}} loses access right away and stays on the list as deactivated. You can reactivate them later.",
            "Continue": "Yes, deactivate"
          },
          "ReactivateConfirm": {
            "Title": "Reactivate this user?",
            "Body": "{{name}} gets their access back with the role they had before.",
            "Continue": "Yes, reactivate"
          }
        },
        "Deactivate": {
          "Success": "{{name}} has been deactivated.",
          "Errors": {
            "Conflict": "This user is already deactivated.",
            "NotFound": "This user is no longer on the tenant.",
            "Forbidden": "You do not have permission to deactivate this user.",
            "Generic": "The user could not be deactivated. Try again."
          }
        },
        "Reactivate": {
          "Success": "{{name}} has been reactivated.",
          "Errors": {
            "Conflict": "This user is not deactivated.",
            "NotFound": "This user is no longer on the tenant.",
            "Forbidden": "You do not have permission to reactivate this user.",
            "Generic": "The user could not be reactivated. Try again."
          }
        }
      },
      "Columns": {
        "Role": "ROLE",
        "CanDo": "CAN DO",
        "Affects": "AFFECTS",
        "Users": "USERS"
      },
      "Affects": {
        "TenantWide": "Tenant-wide",
        "LinkDevices": "Link devices",
        "EveryDevice": "Every device",
        "OneDevice": "One device"
      },
      "Error": {
        "Title": "Users could not be loaded",
        "RolesTitle": "Roles could not be loaded",
        "Retry": "Try again"
      },
      "UnknownRole": "This role is not described yet",
      "SummaryMissing": "This role carries no description",
      "AffectsMissing": "This role’s reach is not stated",
      "RoleUsers": {
        "None": "No users hold this role",
        "More": "+{{more}}"
      },
      "Roles": {
        "TenantAdmin": {
          "Name": "Tenant Admin",
          "CanDo": "Settings, users, integrations"
        },
        "Operations": {
          "Name": "Operations",
          "CanDo": "Device actions, plans, workflows"
        },
        "Provisioning": {
          "Name": "Provisioning",
          "CanDo": "Enrolment, linking, device onboarding"
        },
        "Finance": {
          "Name": "Finance",
          "CanDo": "Plans, pricing, billing records"
        },
        "Support": {
          "Name": "Support",
          "CanDo": "Cases, unlock codes, device lookups"
        },
        "Viewer": {
          "Name": "Viewer",
          "CanDo": "Read only"
        },
        "ReleaseAuthority": {
          "Name": "Release Authority",
          "CanDo": "Releases devices from the plan holding them"
        }
      },
      "Notice": {
        "Title": "No mandatory approval gates",
        "Body": "Permitted actions execute on the user’s own authority and are attributed in full. Review is requested by the originator when they want it.",
        "Emphasis": "Changing device state is a distinct permission from editing plans and workflows."
      },
      "Invite": {
        "Trigger": "Invite user",
        "Title": "Invite user",
        "NameLabel": "Name",
        "NamePlaceholder": "Enter name",
        "EmailLabel": "Email",
        "EmailPlaceholder": "Enter email",
        "RoleLabel": "Role",
        "RolePlaceholder": "Select role",
        "Counter": "{{current}}/{{max}}",
        "Submit": "Invite user",
        "Errors": {
          "NameRequired": "Enter a name.",
          "EmailInvalid": "Enter a valid email address.",
          "Duplicate": "A user with this email address already exists.",
          "Forbidden": "You do not have permission to invite users.",
          "Generic": "The invitation could not be sent. Try again."
        },
        "Success": "{{name}} has been invited."
      }
    },
    "ApiAndWebhooks": {
      "Impact": "Affects integrations",
      "CardTitle": "API and webhooks",
      "Description": "Configure API access and webhooks to connect external systems and automate data exchange.",
      "Title": "API and Webhooks",
      "ReadOnly": "Read only",
      "Subline": "Endpoints the platform sends signed state-change events to. Test an endpoint to confirm it receives them.",
      "Inbound": {
        "Title": "Payment events · Inbound",
        "NoteTitle": "Platform events",
        "NoteBody": "Your systems raise Payment Missed and Payment Received.",
        "NoteEmphasis": "The platform never infers payment status and acts on nothing else."
      },
      "Endpoints": "Endpoints",
      "Entitled": "Events entitled",
      "Columns": {
        "Endpoint": "Endpoints",
        "Events": "Events",
        "Health": "Health",
        "Actions": "Actions"
      },
      "Health": {
        "Rate": "{{rate}} · 24h",
        "Failed": "{{failed}} failed",
        "NoDeliveries": "No deliveries · 24h"
      },
      "Actions": {
        "SendTest": "Send test event",
        "SendTestFor": "Send test event to {{endpoint}}",
        "View": "View",
        "ViewFor": "View {{endpoint}}"
      },
      "Test": {
        "Delivered": "Test event delivered",
        "DeliveredDetail": "HTTP {{status}} in {{duration}}",
        "Failed": "Test event failed",
        "NoResponse": "No response",
        "Error": "The test event could not be sent. Try again."
      },
      "Detail": {
        "Title": "Endpoint details",
        "Description": "Read only. Endpoints are configured for your tenant by Cenorion.",
        "Url": "Endpoint URL",
        "Secret": "Signing secret",
        "Events": "Events"
      }
    },
    "Customisation": {
      "Title": "Application Customisation",
      "Description": "Customize how the consumer app appears on devices, including logos, colors, and other brand settings.",
      "Impact": "Affects every device",
      "Subline": "How the consumer application appears on device.",
      "SublineCheckIn": "Changes reach live devices at next check-in.",
      "Discard": "Discard changes",
      "Save": "Save",
      "SectionsLabel": "Customisation sections",
      "Tabs": {
        "DisplayName": "Display name",
        "Logo": "Logo",
        "Palette": "Colour palette",
        "Currency": "Currency Symbol",
        "Typography": "Typography",
        "Theme": "Theme",
        "Appearance": "Appearance"
      },
      "DisplayName": {
        "Title": "Display name",
        "Description": "Shown to holders on the lock screen and in-app messages. Keep it recognisable — this is what identifies you as their financier.",
        "Counter": "{{length}} / {{max}} characters",
        "TooLong": "Display name must be {{max}} characters or fewer.",
        "Required": "Enter a display name."
      },
      "Logo": {
        "Title": "Logo",
        "Rules": "PNG or SVG, square, min 256×256, max 1 MB.",
        "Full": "Full logo",
        "Icon": "Logo icon",
        "Upload": "Drop a file here or click to browse",
        "UploadLabel": "Upload {{label}}",
        "ReplaceLabel": "Replace {{label}}",
        "Remove": "Remove",
        "Replace": "Replace",
        "Errors": {
          "Type": "Upload a PNG or SVG file.",
          "Size": "The file is larger than 1 MB.",
          "Unreadable": "The image size could not be read. Try another file.",
          "NotSquare": "The logo must be square.",
          "TooSmall": "The logo must be at least 256×256."
        },
        "IconRequired": "Upload a logo icon. Devices show it wherever the brand appears."
      },
      "Palette": {
        "Title": "Colour palette",
        "Description": "Applied to buttons, headers and accents in the Onari app.",
        "Hex": "{{label}} hex code",
        "UsedFor": "Used for",
        "Roles": {
          "primary": "Primary",
          "secondary": "Secondary",
          "accent": "Accent",
          "surface": "Surface"
        },
        "Usage": {
          "PrimaryButtons": "Primary buttons",
          "Links": "Links",
          "ActiveStates": "Active states",
          "LockScreen": "Lock screen background",
          "Headers": "Headers",
          "StrongText": "Strong text/icons",
          "Highlights": "Highlights",
          "ProgressBars": "Progress bars",
          "Badges": "Badges & warnings",
          "AppBackground": "App background",
          "Cards": "Cards",
          "InputFields": "Input fields"
        }
      },
      "Currency": {
        "Title": "Currency symbol",
        "Description": "Shown against payment amounts in the app. Symbol only — full number/locale formatting stays out of V1.",
        "Currency": "Currency",
        "Symbol": "Symbol"
      },
      "Typography": {
        "Title": "Typography",
        "Description": "Upload a custom font or use the system default. System default is recommended — it renders reliably across every device.",
        "System": "System default",
        "Google": "Google Fonts",
        "Custom": "Custom font",
        "SearchLabel": "Search Google Fonts",
        "SearchPlaceholder": "Search google fonts here..",
        "ClearSearch": "Clear search",
        "NoMatches": "No fonts match your search.",
        "ChangeFont": "Change font",
        "Upload": "Upload custom font",
        "UploadLabel": "Upload custom font",
        "UploadHint": "Drag and drop your font file here, or upload from your device.",
        "UploadButton": "Upload font",
        "Rules": ".TTF, .OTF · Max 10MB",
        "Errors": {
          "Type": "Upload a .ttf or .otf font file.",
          "Size": "The file is larger than 10 MB."
        }
      },
      "Theme": {
        "Title": "Custom Themes",
        "Description": "How your brand color gets applied across the app. Each preset guarantees accessible contrast; pick the one that best matches your brand voice.",
        "Continue": "Continue",
        "Presets": {
          "signature": {
            "Title": "Signature",
            "Description": "Logo,\nNeutral CTAs.\nSafest with any palette."
          },
          "branded": {
            "Title": "Branded",
            "Description": "Brand drives primary\nCTAs. Auto-checks\ncontrast."
          },
          "duotone": {
            "Title": "Duotone",
            "Description": "Primary for CTAs,\nSecondary for headers."
          }
        }
      },
      "Appearance": {
        "Title": "Appearance",
        "Description": "Whether the app follows the holder's system setting, or is locked to light or dark. Most tenants leave this on System.",
        "Light": "Light",
        "Dark": "Dark",
        "System": "System"
      },
      "Preview": {
        "Logo": "Logo preview",
        "Typography": "Typography preview",
        "Button": "Button preview",
        "Accent": "Accent preview",
        "Greeting": "Good morning,",
        "HolderName": "Amara K.",
        "MakePayment": "Make a payment",
        "AccentCard": "Your next payment is due soon"
      },
      "Load": {
        "Loading": "Loading branding",
        "Error": "Branding could not be loaded",
        "Retry": "Try again"
      },
      "Publish": {
        "Success": "Branding published. Devices pick it up on their next check-in.",
        "Errors": {
          "Invalid": "A logo was rejected. Check it is a valid PNG or SVG, square, 256 to 2048 px, and not animated.",
          "Forbidden": "You don't have permission to change branding.",
          "Generic": "Branding could not be published. Please try again."
        }
      },
      "Confirm": {
        "Discard": {
          "Title": "Discard your changes?",
          "Body": "Every edit since the last save will be lost. This cannot be undone.",
          "Continue": "Discard changes"
        },
        "Publish": {
          "Title": "Publish branding to devices?",
          "Body": "Every device under your tenant picks up the new branding on its next check-in.",
          "Continue": "Publish"
        }
      }
    },
    "Whitelists": {
      "Title": "Whitelist Restrictions - Applications & Calls",
      "Description": "Define device access during enforcement, including emergency and unlock options.",
      "Impact": "Affects enforcement",
      "Subline": "Named lists of what stays reachable while a device is locked, plus policy for emergency dialling, offline behaviour and unlock codes.",
      "New": "New whitelist",
      "ShowingRange": "Showing {{from}}–{{to}} of {{total}}",
      "Columns": {
        "List": "List",
        "Allows": "Allows",
        "UsedIn": "Used in",
        "LockedNow": "Locked now",
        "Actions": "Actions"
      },
      "Actions": {
        "Edit": "Edit",
        "Duplicate": "Duplicate",
        "ViewFor": "View {{name}}",
        "EditFor": "Edit {{name}}",
        "DuplicateFor": "Duplicate {{name}}"
      },
      "Detail": {
        "NotApplied": "Not applied to any workflow yet.",
        "Rename": "Rename whitelist",
        "Applications": "Applications reachable while locked",
        "PhoneNumbers": "Phone numbers reachable while locked",
        "AddApplication": "Add application",
        "AddPhoneNumber": "Add phone number",
        "Fixed": "Fixed",
        "Remove": "Remove",
        "RemoveFor": "Remove {{name}}",
        "ImpactTitle": "Impact of saving",
        "ImpactBody": "{{devices}} devices currently locked under this profile will pick up the change at next check-in. {{workflows}} workflows reference this whitelist; the reference stays intact."
      },
      "NotTracked": "Not tracked yet",
      "Error": {
        "Title": "Whitelists could not be loaded",
        "Retry": "Try again"
      },
      "Form": {
        "Created": "Whitelist “{{name}}” created",
        "Saved": "Whitelist “{{name}}” saved",
        "TitleNew": "New whitelist",
        "TitleEdit": "Edit whitelist",
        "TitleDuplicate": "Duplicate whitelist",
        "Subline": "Choose what stays reachable on a locked device. Fixed entries are on every whitelist.",
        "Section": "this whitelist",
        "Name": "Whitelist name",
        "Id": "ID",
        "IdGenerated": "Generated on save",
        "CopyName": "Copy of {{name}}",
        "Cancel": "Cancel",
        "Save": "Save",
        "FixedDetail": "Always reachable · cannot be removed",
        "EmergencyNumbers": "Emergency numbers",
        "EmergencyDetail": "Resolved on the device · cannot be removed",
        "ImpactBody": "{{devices}} devices currently locked under this whitelist will pick up the change at next check-in.",
        "Errors": {
          "NameRequired": "Enter a whitelist name",
          "NameTooLong": "Use {{max}} characters or fewer",
          "NameTaken": "A whitelist with this name already exists",
          "Load": "This whitelist could not be loaded",
          "Stale": {
            "Title": "This whitelist changed since you opened it",
            "Description": "Someone else saved it in the meantime. Reload to see the latest version; your edits will be lost.",
            "Reload": "Reload"
          },
          "Refused": {
            "Title": "The whitelist could not be saved",
            "Description": "An entry is repeated or not allowed. Check the applications and phone numbers."
          },
          "Failed": {
            "Title": "The whitelist could not be saved",
            "Description": "Something went wrong. Your edits are kept; try saving again."
          }
        },
        "Add": "Add",
        "AddApplication": {
          "Name": "App name",
          "Package": "Package name",
          "PackageHint": "The Android package id, for example com.example.pay",
          "Errors": {
            "NameRequired": "Enter the app name",
            "NameTooLong": "Use {{max}} characters or fewer",
            "PackageRequired": "Enter the package name",
            "PackageInvalid": "Enter a package name such as com.example.pay",
            "PackageFixed": "This app is always reachable, so it is already on every whitelist",
            "PackageTaken": "This app is already on the whitelist"
          }
        },
        "AddPhoneNumber": {
          "Label": "Label",
          "Number": "Phone number",
          "Country": "Country code",
          "Errors": {
            "LabelRequired": "Enter a label",
            "LabelTooLong": "Use {{max}} characters or fewer",
            "NumberInvalid": "Enter a valid number, for example {{example}}",
            "NumberTaken": "This number is already on the whitelist"
          },
          "ShortCodeHint": "A service short code such as *101# needs no country code."
        },
        "Workflows": {
          "Label": "Workflows (optional)",
          "Placeholder": "Select workflows",
          "Selected_one": "{{count}} workflow selected",
          "Selected_other": "{{count}} workflows selected",
          "MappedTo": "Mapped to {{list}}",
          "Move": {
            "Title": "Move workflow?",
            "Body": "This workflow is mapped to {{list}}. Move it to this whitelist?",
            "Confirm": "Move"
          }
        }
      },
      "Empty": {
        "Title": "No whitelists yet",
        "Description": "Create a whitelist to choose which apps and numbers stay reachable on a locked device."
      },
      "UsedIn": {
        "None": "Not used",
        "Count_one": "{{count}} workflow",
        "Count_other": "{{count}} workflows"
      }
    }
  },
  "Profile": {
    "Title": "Profile information",
    "Description": "Manage your personal Cenorion account settings.",
    "SectionsNav": "Profile sections",
    "Sections": {
      "PersonalDetails": "Personal details",
      "Password": "Password",
      "Authentication": "Authentication",
      "ActiveSessions": "Active sessions",
      "EmailNotifications": "Email notifications"
    },
    "Password": {
      "Description": "Change your Cenorion password. Not available for SSO-only tenants.",
      "Fields": {
        "Current": "Current password",
        "New": "New password",
        "Confirm": "Confirm password"
      },
      "Hint": "Minimum <strong>{{min}} characters,</strong> including upper and lower case letters, a number and a symbol.",
      "Validation": {
        "CurrentRequired": "Enter your current password.",
        "NewRequired": "Enter a new password.",
        "ConfirmRequired": "Confirm your new password.",
        "MinLength": "Use at least 12 characters.",
        "MaxLength": "Use at most 256 characters.",
        "Lowercase": "Include a lower case letter.",
        "Uppercase": "Include an upper case letter.",
        "Number": "Include a number.",
        "Symbol": "Include a symbol.",
        "SameAsCurrent": "Choose a password different from your current one.",
        "Mismatch": "Passwords don’t match."
      },
      "Change": {
        "Submit": "Update password",
        "Success": "Your password was changed.",
        "Confirm": {
          "Title": "Change your password?",
          "Body": "You’ll use the new password the next time you sign in. You’ll stay signed in on this device.",
          "Action": "Change password"
        }
      },
      "Errors": {
        "Title": "We couldn’t change your password",
        "WrongCurrent": "Your current password is incorrect. Check it and try again.",
        "SessionExpired": "Your session can’t change the password. Sign out, sign in again, then try once more.",
        "Rejected": "This password can’t be used. Choose a different one.",
        "TooManyAttempts": "Too many attempts. Try again in a minute.",
        "Generic": "Something went wrong on our side. Try again in a moment."
      }
    },
    "ComingSoon": "Coming soon",
    "NotAvailable": "Not available yet",
    "PersonalDetails": {
      "Description": "Your name and contact email for this Cenorion account",
      "FullName": "Full name",
      "JobRole": "Job role (optional)",
      "Email": "Email",
      "Role": "Role"
    },
    "Authentication": {
      "Description": "Sign-in factors for this account.",
      "Mfa": {
        "Title": "Multi-factor authentication",
        "Description": "MFA is required for all Cenorion accounts."
      },
      "Totp": {
        "Title": "Authenticator app (TOTP)",
        "Action": "Reset device"
      },
      "BackupCodes": {
        "Title": "Backup codes",
        "Action": "Regenerate"
      }
    },
    "ActiveSessions": {
      "Description": "Devices currently signed in with your account. Revoke any you don’t recognize.",
      "SignOutOthers": "Sign out of all other sessions",
      "Columns": {
        "Device": "Device",
        "Location": "Location",
        "LastActive": "Last active"
      }
    },
    "EmailNotifications": {
      "Description": "Choose which platform events send you an email. In-app notifications are always on.",
      "SecurityAlerts": {
        "Title": "Security alerts",
        "Description": "New sign-in from unrecognized devices, MFA reset, password changed."
      },
      "ReleaseAuthority": {
        "Title": "Release Authority actions",
        "Description": "You are notified when Release, Archive or Bulk operations occur under your grant."
      },
      "BulkSummaries": {
        "Title": "Bulk operation summaries",
        "Description": "Completion reports for bulk registrations, locks and releases you initiated."
      },
      "WorkflowPolicy": {
        "Title": "Workflow policy changes",
        "Description": "Notify me when a workflow version is published or suspended."
      },
      "ApiCredentialExpiry": {
        "Title": "API credential expiry",
        "Description": "Reminders before machine identity secrets expire."
      }
    }
  },
  "PlansAndWorkflows": {
    "Title": "Plans and Workflows",
    "Subtitle": "Build, publish and track the plans and workflows your devices run on.",
    "Tabs": {
      "Plans": "Plans",
      "Workflows": "Workflows"
    },
    "CreateNew": {
      "Label": "Create New",
      "Plan": "Create new plan",
      "Workflow": "Create new workflow"
    }
  },
  "Workflows": {
    "Empty": {
      "Title": "No workflows yet",
      "Body": "A workflow decides what happens to a financed device at each stage: reminders, grace periods and locks. Workflows you create show up here."
    },
    "Actions": {
      "Create": "Create workflow",
      "Edit": "Edit {{name}}",
      "Duplicate": "Duplicate {{name}}"
    },
    "Filters": {
      "Service": "Service",
      "Versions": "Versions",
      "VersionOptions": {
        "DRAFT": "Draft",
        "PUBLISHED": "Published",
        "RETIRED": "Retired"
      },
      "SearchPlaceholder": "Search..",
      "SearchLandmark": "Search workflows"
    },
    "Columns": {
      "Workflow": "WORKFLOW",
      "Service": "SERVICE",
      "Status": "STATUS",
      "Versions": "VERSIONS",
      "Enrolments": "ENROLMENTS",
      "Actions": "Actions"
    },
    "PendingMigration": "{{value}} pending migration",
    "NoMatch": {
      "Title": "No workflows match",
      "Body": "Try a different name, or clear the service and versions filters."
    },
    "Overview": {
      "Title": "Workflows",
      "Active": "Active",
      "Enrolments": "Enrollments",
      "Drafts": "Drafts"
    },
    "Services": {
      "dfpost": "DF Post-paid",
      "dfpre": "DF Pre-paid",
      "sc": "Supply Chain",
      "sim": "SIM Control"
    },
    "Draft": "Draft",
    "Status": {
      "PUBLISHED": "Published",
      "RETIRED": "Retired",
      "DRAFT": "Draft"
    },
    "Unavailable": "Not available yet.",
    "Panel": {
      "Stages": "Stages · {{count}} stages",
      "Close": "Close {{name}}",
      "PaymentReceived": "Payment Received",
      "Cure": "Cure",
      "LoadError": "Couldn't load this workflow",
      "NotFound": {
        "Title": "Workflow not found",
        "Body": "This workflow no longer exists, or isn't in your organisation."
      },
      "Subtitle": "{{service}} · {{version}}",
      "VersionWithStatus": "v{{version}} ({{status}})",
      "NoStages": "This version has no stages yet.",
      "Versions": "Versions",
      "Published": "Published {{date}}",
      "Created": "Created {{date}}",
      "Enrolments": "{{value}} live enrolments",
      "Enrolments_one": "{{value}} live enrolment",
      "Enrolments_other": "{{value}} live enrolments"
    },
    "Stage": {
      "AfterDays": "After {{count}} days",
      "AfterDays_one": "After {{count}} day",
      "AfterDays_other": "After {{count}} days",
      "AfterDaysFrom": "After {{count}} days from {{anchor}}",
      "AfterDaysFrom_one": "After {{count}} day from {{anchor}}",
      "AfterDaysFrom_other": "After {{count}} days from {{anchor}}",
      "FromAnyStage": "From any stage",
      "OnCure": "On cure",
      "OpensEpisode": "Opens episode",
      "ReturnsTo": "Returns to {{name}}",
      "Position": "Stage {{position}}"
    },
    "Event": {
      "activation_complete": "Activation complete",
      "payment_missed": "Payment missed",
      "payment_received": "Payment received",
      "final_payment": "Final payment"
    },
    "Anchor": {
      "episode_open": "episode open",
      "stage_entry": "stage entry",
      "due_date": "due date"
    },
    "Policy": {
      "OnEntry": "On entry",
      "DueOffset": "T{{offset}}",
      "EpisodeDay": "Day {{value}}",
      "EntryDay": "Day {{value}} after entry",
      "PartialToFull": "Full lock after {{count}} days",
      "PartialToFull_one": "Full lock after {{count}} day",
      "PartialToFull_other": "Full lock after {{count}} days",
      "CureAction": {
        "priority_unlock_reset": "Priority unlock and reset"
      }
    },
    "Action": {
      "FlagDefaultReview": "Flag for default review",
      "MessageCompletion": "Completion message",
      "QueueReleaseAuthority": "Queue for release authority"
    },
    "Publish": {
      "Action": "Publish",
      "Label": "Publish {{name}}",
      "Title": "Publish {{name}}?",
      "Body": "Version {{version}} of this workflow goes live.",
      "BodyAssignService": "Assign Service for DF Post-paid only works once this workflow is published. After you publish, devices can be enrolled on version {{version}}.",
      "Confirm": "Publish",
      "Success": "{{name}} published as version {{version}}.",
      "Error": {
        "Title": "Couldn’t publish this workflow",
        "Rules": {
          "escalation_not_monotonic": "A stage restricts the device less than the stage before it. Each stage must restrict at least as much as the one above.",
          "timers_out_of_order": "The stages’ day counts are out of order. Each later stage must start on a later day than the one before it.",
          "cure_unreachable": "A stage locks the device but nothing can unlock it on payment. Every locking stage needs a cure.",
          "return_not_backwards": "A stage returns to itself or to a later stage. A return must point to an earlier stage.",
          "workflow_empty": "This draft has no stages. Add at least one stage before publishing."
        },
        "Rule": "This draft breaks a stage rule, so it can’t be published yet. Fix its stages and try again.",
        "NotFound": "This workflow no longer exists. The list has been refreshed.",
        "Forbidden": "Your role can’t publish workflows.",
        "Generic": "Something went wrong while publishing. Try again."
      }
    }
  },
  "Header": {
    "Unavailable": "Not available on this page yet."
  }
}
